const ERROR_CODES = {
    // Request operations
    REQUEST_CREATION_FAILED: 'Une erreur est survenue lors de la création de la demande',
    QUOTA_EXCEEDED: 'Quota atteint : impossible de créer cette demande.',
    QUOTA_WARNING: 'Quota dépassé (avertissement) : vous pouvez créer cette demande, mais vous avez déjà atteint votre quota.',
    // Password reset
    RESET_EMAIL_SENT: 'Si un compte existe avec cet identifiant, un email a été envoyé.',
    RESET_RATE_LIMITED: 'Trop de tentatives. Réessayez plus tard.',
    RESET_TOKEN_REQUIRED: 'Token et mot de passe requis.',
    RESET_PASSWORD_WEAK: 'Le mot de passe doit contenir au moins 4 caractères.',
    RESET_TOKEN_INVALID: 'Lien invalide ou expiré. Veuillez refaire une demande.',
    RESET_USER_NOT_FOUND: 'Utilisateur introuvable.',
    RESET_PASSWORD_SUCCESS: 'Votre mot de passe a été réinitialisé avec succès.',
  };

  export { ERROR_CODES };
